module.exports = __webpack_public_path__ + "img/contact1.abde9ae.png";